module.exports = __webpack_public_path__ + "static/img/flexible-bg.8966a7b0.png";